import React from 'react'
import { Script } from 'gatsby'

const Schema = () => {
    return (
        <div>
            <Script type="application/ld+json">
                {`
        {
          "@context":"http://schema.org",
          "@type" : "WebSite",
          "name" : "Defencath",
          "url" : "https://www.defencath.com/"
        }
      `}
            </Script>
        </div>
    )
}

export default Schema
